import ZoneFormItem from "@delivery-management/SetShippingFees/ZoneFormItem.tsx";
import {
  deliverySetting0,
  setDeliverySetting0
} from "@/react/SetShippingFeesView/SetShippingFeesLogic.tsx";
import { Fragment, useEffect } from "react";
import _ from "lodash";
import { deliverySettingsZone } from "@/react/DeliveryManagementView/google-map-logic.ts";

let firstTime = true

const DeliveryZoneList = () => {
  useEffect(() => {
    if (deliverySettingsZone()?.length && _.isEmpty(deliverySetting0) && firstTime) {
      setDeliverySetting0(deliverySettingsZone()[0])
      firstTime = false
    }
  }, [deliverySettingsZone()?.length])
  return (
    <div className="no-scrollbar self-stretch flex-1 rounded-[6px] overflow-y-auto shrink-0 flex flex-col items-start justify-start p-[10px] text-left text-[14px] text-[#212121] font-[Mulish] gap-2">
      {deliverySettingsZone().map((d, i) => (
        <Fragment key={i}>
          <ZoneFormItem setting={d} />
        </Fragment>
      ))}
    </div>
  )
}

export default DeliveryZoneList;